import { useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  setSelectedAdGroupFilterBD,
  setSelectedCampaignFilterBD,
  setSelectedKeyword,
  setSelectedMatchTypeFilterBD,
  setSelectedTrafficSourceFilterBD,
} from "../../../../../../../features/trendsSlice";
import { Box } from "@mui/system";
import FilterComponent from "../../../../../../ReusableFIlterComponent/FilterComponent";
import { useSearchParams } from "react-router-dom";

const TrendsBDKwMtfilterObjs = () => {
  const dispatch = useDispatch();
  const [searchMatchType, setSearchMatchType] = useState("");
  const [searchTrafficSource, setSearchTrafficSource] = useState("");
  const [searchCampaign, setSearchCampaign] = useState("");
  const [searchAdGroup, setSearchAdGroup] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const {
    keywordMatchTypeDataTrendsBreakdown,
    selectedMatchTypeFilterBD,
    selectedCampaignFilterBD,
    selectedAdGroupFilterBD,
    selectedTrafficSourceFilterBD,
  } = useSelector((state: any) => state.trends);
  const datakeywordMatchTypeDataTrendsBreakdown =
    keywordMatchTypeDataTrendsBreakdown?.data?.data?.query_output || [];

  const filterConfig = [
    {
      key: "match type",
      label: "Select one Match Type or more",
      searchTerm: searchMatchType,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchMatchType(e.target.value),
      selectedOption: selectedMatchTypeFilterBD,
      filterName: "matchtype",
      data: datakeywordMatchTypeDataTrendsBreakdown,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setSelectedMatchTypeFilterBD(updatedSelection)),
      count: selectedMatchTypeFilterBD && selectedMatchTypeFilterBD.length,
      colorSelected:
        selectedMatchTypeFilterBD !== null &&
        selectedMatchTypeFilterBD.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
    {
      key: "traffic source",
      label: "Select one Traffic Source or more",
      searchTerm: searchTrafficSource,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchTrafficSource(e.target.value),
      selectedOption: selectedTrafficSourceFilterBD,
      filterName: "traffic_source",
      data: datakeywordMatchTypeDataTrendsBreakdown,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setSelectedTrafficSourceFilterBD(updatedSelection)),
      count:
        selectedTrafficSourceFilterBD && selectedTrafficSourceFilterBD.length,
      colorSelected:
        selectedTrafficSourceFilterBD !== null &&
        selectedTrafficSourceFilterBD.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
    {
      key: "campaign",
      label: "Select one Campaign or more",
      searchTerm: searchCampaign,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchCampaign(e.target.value),
      selectedOption: selectedCampaignFilterBD,
      filterName: "campaign_name",
      data: datakeywordMatchTypeDataTrendsBreakdown,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setSelectedCampaignFilterBD(updatedSelection)),
      count: selectedCampaignFilterBD && selectedCampaignFilterBD.length,
      colorSelected:
        selectedCampaignFilterBD !== null && selectedCampaignFilterBD.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
    {
      key: "adgroup",
      label: "Select one Ad Group or more",
      searchTerm: searchAdGroup,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchAdGroup(e.target.value),
      selectedOption: selectedAdGroupFilterBD,
      filterName: "adgroup_name",
      data: datakeywordMatchTypeDataTrendsBreakdown,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setSelectedAdGroupFilterBD(updatedSelection)),
      count: selectedAdGroupFilterBD && selectedAdGroupFilterBD.length,
      colorSelected:
        selectedAdGroupFilterBD !== null && selectedAdGroupFilterBD.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
  ];

  const clearFilters = () => {
    dispatch(setSelectedMatchTypeFilterBD(null));
    dispatch(setSelectedCampaignFilterBD(null));
    dispatch(setSelectedAdGroupFilterBD(null));
    dispatch(setSelectedTrafficSourceFilterBD(null));
    dispatch(setSelectedKeyword(null));
    setSearchMatchType("");
    setSearchTrafficSource("");
    setSearchCampaign("");
    setSearchAdGroup("");
    searchParams.delete("keywordSearch");
    searchParams.delete("filters");
    setSearchParams(searchParams);
  };
  return (
    <Box>
      <FilterComponent
        filterConfig={filterConfig}
        clearFilters={clearFilters}
      />
    </Box>
  );
};

export default TrendsBDKwMtfilterObjs;
